import Home from '@/components/common/Home.vue';

export const billingRoutes = {
  path: '/billing',
  component: Home,
  name: 'Billing',
  redirect: '/billing/detail',
  meta: {
    title: 'Billing',
  },
  children: [
    {
      path: 'detail',
      component: () => import('@/views/billing/DetailBilling.vue'),
      meta: {
        title: 'Detail Billing',
      },
    },
    {
      path: 'adv/billing',
      component: () => import('@/views/billing/advertiser/AdvertiserBilling.vue'),
      meta: {
        title: 'Advertiser Billing',
      },
    },
    {
      path: 'adv/invoice/app',
      component: () => import('@/views/billing/advertiser/AdvInvoiceApplication'),
      meta: {
        title: 'Adv Invoice Application',
      },
    },
    {
      path: 'aff/billing/app',
      component: () => import('@/views/billingSending/AffBillingApp.vue'),
      meta: {
        title: 'Aff Billing Application',
      },
    },
    {
      path: 'aff/billing',
      component: () => import('@/views/billing/affiliate/AffiliateBilling.vue'),
      meta: {
        title: 'Affiliate Billing',
      },
    },
    {
      path: 'aff/hedge/app',
      component: () => import('@/views/billing/affiliate/AffHedgeApp.vue'),
      meta: {
        title: 'Aff Hedge Management',
      },
    },
    {
      path: 'adv/hedge/app',
      component: () => import('@/views/billing/advertiser/AdvHedgeApp.vue'),
      meta: {
        title: 'Adv Hedge Management',
      },
    },
    {
      path: 'aff/payment/app',
      component: () => import('@/views/billing/affiliate/AffPaymentApp.vue'),
      meta: {
        title: 'Aff Payment Management',
      },
    },
    {
      path: 'adv/payment-receipt/app',
      component: () => import('@/views/billing/advertiser/AdvPaymentReceiptManagement.vue'),
      meta: {
        title: 'Adv Payment Receipt Management',
      },
    },
    {
      path: 'adv/billing-entity/report',
      component: () => import('@/views/billing/advertiser/AdvEntityReport.vue'),
      meta: {
        title: 'Adv Billing Entity Report',
      },
    },
    {
      path: 'aff/billing-entity/report',
      component: () => import('@/views/billing/affiliate/AffEntityReport.vue'),
      meta: {
        title: 'Aff Billing Entity Report',
      },
    },
  ],
};
